import { ISelectMiniOption, SelectMini } from '@salecycle/ui-component-library';
import { useFeatureFlags } from 'core/app/AppContext';
import { FC, useMemo } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

const getPresetLanguage = (languages: ISelectMiniOption[]): ISelectMiniOption => {
  const currentLng = i18next.language?.split('-')[0] ?? 'en';
  const selected = languages.find(language => language.value === currentLng);
  if (selected) {
    return selected;
  }
  return languages.find(language => language.value === 'en') ?? languages[0];
};

const BASE_UI_LANGUAGES: ISelectMiniOption[] = [
  { value: 'en', label: 'EN' },
  { value: 'fr', label: 'FR' },
  { value: 'it', label: 'IT' },
  { value: 'es', label: 'ES' },
];

export const LanguagePicker: FC = () => {
  const { t } = useTranslation();
  const { flagEnabled } = useFeatureFlags();
  const languages: ISelectMiniOption[] = useMemo(() => {
    const list = [...BASE_UI_LANGUAGES];
    if (flagEnabled('ld-jap-locale')) {
      list.push({ value: 'jp', label: 'JP' });
    }
    return list;
  }, [flagEnabled]);
  const selectedLanguage: ISelectMiniOption = getPresetLanguage(languages);
  const handleOnChange = (option: ISelectMiniOption) => {
    const currentLanguage = i18next.language?.split('-')[0];
    if (option.value === currentLanguage) {
      return;
    }
    i18next.changeLanguage(option.value);
  };
  return (
    <div data-testid="LanguagePicker">
      <SelectMini
        ariaLabel={t('language.select.label')}
        options={languages}
        menuWidth="auto"
        onChange={handleOnChange}
        value={selectedLanguage}
      />
    </div>
  );
};
